import { get } from "../../service/api";

const getMerchantInvoiceDetail = async (merchantId, merchantInvoiceId) => {
  try {
    const response = await get(
      `/merchant/${merchantId}/merchantInvoice/${merchantInvoiceId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error getMerchantInvoiceDetail:", error);
    throw error;
  }
};

export default getMerchantInvoiceDetail;
